/* src/app/agent-builder/agent-builder-messages-log/agent-builder-messages-log.component.scss */
.expand-log-container {
  display: flex;
  flex-direction: row;
  gap: 16px;
  height: 450px;
  width: 100%;
}
.expanded-log {
  width: 100%;
}
.expand-log-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 33%;
}
.search-box {
  padding: 8px;
}
.search-box input {
  width: 188px;
  margin-bottom: 8px;
  display: block;
}
.search-box nz-date-picker {
  width: 300px;
  margin-bottom: 8px;
  display: block;
}
.search-box button {
  width: 90px;
}
.search-button {
  margin-right: 8px;
}
.expand-log-label {
  font-weight: 500;
}
/*# sourceMappingURL=agent-builder-messages-log.component.css.map */
